import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { SPAIN_PROVINCES } from '@/utils/provinces.ts';

interface ProvinceSelectorProps {
  value: string;
  onChange: (province: string) => void;
  disabled?: boolean;
  label?: string;
}

const ProvinceSelector: React.FC<ProvinceSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  label = 'Provincia',
}) => (
  <Autocomplete
    options={SPAIN_PROVINCES}
    value={value || null}
    onChange={(_e, newValue: string | null) => onChange(newValue || '')}
    renderInput={(params) => (
      <TextField {...params} label={label} placeholder="Selecciona provincia..." size="small" />
    )}
    fullWidth
    disabled={disabled}
  />
);

export default ProvinceSelector;
